import React from 'react';
import CalculatorStep from './CalculatorStep';
import PropTypes from 'prop-types';

class Step2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: this._evaluateAnswers(props.answers)
    };

    this.isValidated = this.isValidated.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.checkSkipStep = this.checkSkipStep.bind(this);
  }

  componentWillMount() {
    this.checkSkipStep();
  }

  componentDidUpdate() {
    this.checkSkipStep();
  }

  // Called when the user attempts to advance to the next step
  isValidated() {
    let isDataValid = Boolean(this.state.answers[0].isValid);

    this.props.onSubmit(this.state.answers);
    
    return isDataValid;
  }

  handleChange(questionNumber, value) {
    const previousAnswer = this.state.answers[questionNumber];
    if (typeof previousAnswer !== 'undefined' && previousAnswer.value === value) {
      return; // No update - nothing changed
    }

    this.setState(state => {
      let answers = state.answers;

      // Evaluate the validity of the form and update state
      return { answers: this._evaluateAnswer(answers, questionNumber, value) };
    });
  }

  checkSkipStep() {
    if (this.props.skipToStep && this.props.skipToStep > 0) {
      this.props.jumpToStep(this.props.skipToStep);
    }
  }

  _evaluateAnswers(answers) {
    answers.forEach((answer, i) => {
      answers = this._evaluateAnswer(answers, i, answer.value);
    });

    return answers;
  }

  _evaluateAnswer(answers, currentQuestionNumber, newValue) {
    answers.forEach((answer, i) => {
      const isValid = typeof newValue !== 'undefined';
      newValue = newValue.trim().length > 0 ? newValue : "0";
      
      if (i === currentQuestionNumber) {
        answer.value = newValue;
        answer.timestamp = new Date();
        answer.isValid = isValid;
      }
      
      answers[i] = answer;
    });

    return answers;
  }

  render() {
    const questions = this.props.questions.map((question, i) => {
      const answer = this.state.answers[i];
      question.validationState = answer.validationState;
      question.validationMessage = answer.validationMessage;
      question.defaultValue = answer.value;
      
      return question;
    });

    return (
      <CalculatorStep
          name={"websiteSessionsMthly"}
          questions={questions}
          handleChange={this.handleChange}
          articleKey="visitors"
      />
    );
  }
}

Step2.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.int,
      timestamp: PropTypes.dateTime
    }).isRequired
  ),
  onSubmit: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      required: PropTypes.bool,
      type: PropTypes.string
    })
  ).isRequired,
  skipToStep: PropTypes.number
};

export default Step2;
